// components/searchContacts.js
import axios from "axios";

const searchContacts = async (contactId) => {
  try {
    // Keep the same port as in your original code
    const response = await axios.post(
      "/api/search-contacts", 
      {
        query: contactId,
        properties: ["firstname", "lastname", "email", "country", "phone", "alt_number", "call_number"]
      },
      {
        headers: {
          'Cache-Control': 'no-cache, no-store',
          'Pragma': 'no-cache',
          'Expires': '0'
        },
        params: {
          _t: new Date().getTime()
        }
      }
    );

    // Log the full response for debugging
    console.log("Full API Response:", response.data);
    
    // Handle various response structures based on what we've seen in the network tab
    if (response && response.data) {
      let contactData = null;
      
      // Case 1: If response.data has direct 'id' and 'properties'
      if (response.data.id && response.data.properties) {
        contactData = response.data;
      }
      // Case 2: If response.data has a 'results' array
      else if (response.data.results && Array.isArray(response.data.results) && response.data.results.length > 0) {
        contactData = response.data.results[0];
      }
      // Case 3: If response.data has numeric keys (like '0')
      else if (response.data['0'] && response.data['0'].id) {
        contactData = response.data['0'];
      }
      
      // If we found a valid contact object, return it
      if (contactData && contactData.id) {
        return contactData;
      }
    }
    
    // If we get here, no valid contact was found
    throw new Error("No contact found");
  } catch (error) {
    console.error("Error searching contacts:", error);
    
    // If the error has a response from the server
    if (error.response) {
      if (error.response.data && error.response.data.error) {
        throw new Error(error.response.data.error);
      } else if (error.response.status === 404) {
        throw new Error("API endpoint not found. Server might be running on a different port.");
      } else {
        throw new Error(`Server error (${error.response.status})`);
      }
    } 
    // If the request was made but no response was received
    else if (error.request) {
      throw new Error("No response from server. Please check if the API server is running.");
    } 
    // Something else caused the error
    else if (error.message) {
      throw new Error(error.message);
    } 
    // Fallback error message
    else {
      throw new Error("An error occurred while searching for contacts");
    }
  }
};

export default searchContacts;
